import { useTranslation } from 'react-i18next'

import { Alert, ComboBox } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'
import { issueExchangeStatus } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/constants'
import { exchangeOrdersAutomaticCreationValues } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/constants'
import PaymentWindowInput from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/ExchangesConfiguration/PaymentWindowInput/PaymentWindowInput'
import { allowedExchangeMethodsIncludesSomeVariantsType } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/helpers'

import { getAvailableIssueExchangeStatus } from './helpers'
import * as Styles from './styles'

const IssueExchangeAtStatusSelector = ({
  issueExchangeAtStatus,
  setIssueExchangeAtStatus,
  allowedPreferences,
  exchangeOrdersAutomaticCreation,
  allowedExchangeMethods,
  availableIssueExchangeStatus,
  disabled,
  exchangePaymentExpiration,
  setExchangePaymentExpiration,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    !allowedPreferences.includes(preferences.exchangeOrdersAutomaticCreation) ||
    exchangeOrdersAutomaticCreation !== exchangeOrdersAutomaticCreationValues.automatic ||
    !allowedExchangeMethodsIncludesSomeVariantsType(allowedExchangeMethods)
  ) {
    return null
  }

  return (
    <Styles.Container>
      <ComboBox
        label={t('Crear nuevo pedido')}
        value={issueExchangeAtStatus}
        handleChange={e => setIssueExchangeAtStatus(e.target.value)}
        menuItems={getAvailableIssueExchangeStatus(availableIssueExchangeStatus).map(o => ({
          label: t(o.label),
          value: o.value,
        }))}
        fullWidth
        disabled={disabled}
      />
      {issueExchangeAtStatus === issueExchangeStatus.inProgress && (
        <PaymentWindowInput
          value={exchangePaymentExpiration}
          onChange={setExchangePaymentExpiration}
          disabled={disabled}
        />
      )}
      {issueExchangeAtStatus === issueExchangeStatus.shipped && (
        <Alert type="warning">
          {t('Requiere integración con un servicio de logística con actualización de estado en tiempo real')}
        </Alert>
      )}
    </Styles.Container>
  )
}

export default IssueExchangeAtStatusSelector
